import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchNotificationList } from "./notificationApi";
import { NotificationState } from "../../../features/view/public/Notifications/NotificationTypes";

const initialState: NotificationState = {
  notifications: {
    data: [],
    loader: false,
  },
};

export const fetchNotificationListAsync = createAsyncThunk(
  "orders/notification_history/",
  async () => {
    const response = await fetchNotificationList();
    return response;
  }
);

export const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationListAsync.pending, (state) => {
        state.notifications.loader = true;
      })
      .addCase(fetchNotificationListAsync.fulfilled, (state, action: any) => {
        state.notifications.loader = false;
        state.notifications.data = action?.payload?.data?.data || [];
      })
      .addCase(fetchNotificationListAsync.rejected, (state) => {
        state.notifications.loader = false;
      });
  },
});

export default NotificationSlice.reducer;
